"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cosmos_1 = require("components/cosmos");
const translationContext_1 = require("configs/translationContext");
const error_state_svg_1 = require("./assets/error-state.svg");
const ErrorState = () => {
    const { t } = (0, translationContext_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", { className: "_d-flex _flex-column _flex-wrap _align-items-center _justify-content-center _py-7 _h-full", "data-test": "error-state", children: [(0, jsx_runtime_1.jsx)("div", { className: " _mb-4", children: (0, jsx_runtime_1.jsx)(error_state_svg_1.ReactComponent, { "data-test": "error-state-illustration" }) }), (0, jsx_runtime_1.jsx)("h1", { className: "_text-4 _mb-8 _text-center", children: t('alerts.unexpected_error') }), (0, jsx_runtime_1.jsx)(cosmos_1.Button, { onClick: () => window.location.reload(), className: "_d-flex _justify-content-center _align-items-center", children: t('general.retry') })] }));
};
exports.default = ErrorState;
